import React, { MouseEventHandler, ReactElement } from 'react';
import Link, { LinkProps } from 'atomic/link/link';
import { LocationUpdateParamsInterface } from 'interfaces/location.interface';
import { useLocation } from 'hooks/use-location';

interface DynamicLinkProps extends LinkProps {
    locationParams: LocationUpdateParamsInterface;
}

const DynamicLink: React.FC<DynamicLinkProps> = ({ locationParams, onClick, children, ...props }): ReactElement => {
    const { getUpdatedLocation, updateLocation } = useLocation();

    const handleClick: MouseEventHandler<HTMLAnchorElement> = e => {
        e.preventDefault();

        if (onClick) {
            onClick(e);
        }

        updateLocation(locationParams);
    };

    return (
        <Link href={getUpdatedLocation(locationParams).url} onClick={handleClick} {...props}>
            {children}
        </Link>
    );
};

export default DynamicLink;
